// AUTO-GENERATED by scripts/convert-rn-icons.ts from libs/component-library/src/lib/icons/icons.tsx - do not edit.
import { FxSvg, type FxSvgProps } from '../FxSvg.js';

export const FxChevronRightIcon = (props: FxSvgProps) => (
  <FxSvg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.11788 2.3131C5.31314 2.11784 5.62973 2.11784 5.82499 2.3131L10.6869 7.17503C11.1425 7.63064 11.1425 8.36934 10.6869 8.82495L5.82499 13.6869C5.62973 13.8821 5.31314 13.8821 5.11788 13.6869C4.92262 13.4916 4.92262 13.175 5.11788 12.9798L9.97981 8.11784C10.0449 8.05275 10.0449 7.94723 9.97981 7.88214L5.11788 3.02021C4.92262 2.82495 4.92262 2.50837 5.11788 2.3131Z"
    />
  </FxSvg>
);
